import type { ModuleRoute } from '@/platform/router/types';
const PreferenciasHome = () => <div>Em construção</div>;
export const preferenciasRoutes: ModuleRoute[] = [{ path: '', label: 'Preferências', element: PreferenciasHome, requiredPermissions: [] }];
